import { hot } from 'react-hot-loader';
import React, { useState, useEffect } from "react";
import translations from "../../translations";
import { createTranslations } from "react-ridge-translations";
import Listbox from "../Listbox";
import TextInput from "../TextInput";
import ResultList from "../ResultList";

import {
	getFirstYearFromInputData,
	getLastYearFromInputData,
	filter,
	sortByFromDate,
} from "../../filter";

const Form = (props) => {
	const {
		language = 'en',
		items = [],
	} = props;

	const [ translate ] = useState(createTranslations()(translations, { language: language, fallback: 'en' }));
	const t = translate.use();
	useEffect(() => {
		return () => {
			translate.setOptions([ { language: language, fallback: 'en' } ]);
		};
	}, [ translate, language ]);

	const [ filteredData, setFilteredData ] = useState(items);
	const [ firstYear ] = useState(getFirstYearFromInputData(items));
	const [ lastYear ] = useState(getLastYearFromInputData(items));
	const yearOptions = Array(lastYear - firstYear + 1).fill().map((_, index) => firstYear + index);
	const isFiltered = filteredData !== items;

	const [ textInput, setTextInput ] = useState("");
	const [ fromYear, setFromYear ] = useState(false);
	const [ fromMonth, setFromMonth ] = useState(false);
	const [ toYear, setToYear ] = useState(false);
	const [ toMonth, setToMonth ] = useState(false);

	const [ currentPage, setCurrentPage ] = useState(0);

	const onReset = () => {
		setTextInput("");
		setFromYear(false);
		setFromMonth(false);
		setToYear(false);
		setToMonth(false);
		setFilteredData(items);
		setCurrentPage(0);
	};

	const onSubmit = () => {
		if (textInput === "" && fromYear === false && toYear === false && fromMonth === false && toMonth === false) {
			return;
		}
		setFilteredData(
			filter(
				textInput,
				yearOptions[ fromYear ],
				fromMonth,
				yearOptions[ toYear ],
				toMonth,
				items
			)
		);
		setCurrentPage(0);
	};

	return (
		<div className="pt-react-teaserlist">
			<form className="searchwindow opensearchserver.ignore" onSubmit={ e => e.preventDefault() }>
				<h2>{ t.form.header }</h2>
				<div className="oss-form-inline" autoComplete="off">
					<div className="row">
						<TextInput
							label={ t.textInput.label }
							placeholder={ t.textInput.placeholder }
							value={ textInput }
							onChange={ setTextInput }
							onEnter={ onSubmit }
						/>
					</div>
					<div className="row">
						<Listbox
							label={ t.listboxFromYear.label }
							placeholder={ t.listboxFromYear.placeholder }
							options={ yearOptions }
							selectedIndex={ fromYear }
							onChange={ setFromYear }
						/>
						<Listbox
							label={ t.listboxFromMonth.label }
							placeholder={ t.listboxFromMonth.placeholder }
							options={ t.general.months }
							selectedIndex={ fromMonth }
							onChange={ setFromMonth }
							disabled={ fromYear === false }
							labelDisabled={ t.listboxFromMonth.labelDisabled }
						/>
					</div>
					<div className="row">
						<Listbox
							label={ t.listboxToYear.label }
							placeholder={ t.listboxToYear.placeholder }
							options={ yearOptions }
							selectedIndex={ toYear }
							onChange={ setToYear }
						/>
						<Listbox
							label={ t.listboxToMonth.label }
							placeholder={ t.listboxToMonth.placeholder }
							options={ t.general.months }
							selectedIndex={ toMonth }
							onChange={ setToMonth }
							disabled={ toYear === false }
							labelDisabled={ t.listboxToMonth.labelDisabled }
						/>
					</div>
					<div className="row btn-row">
						<button type="submit"
							className="oss-button-inline"
							onClick={ onSubmit }
							aria-label={ t.form.submitBtnAriaLabel }
						>{ t.form.submitBtn }
						</button>
						{ isFiltered &&
							<button
								type="reset"
								className="oss-button-inline"
								onClick={ onReset }
								aria-label={ t.form.resetBtnAriaLabel }
							>{ t.form.resetBtn }
							</button>
						}
					</div>
				</div>
			</form>
			<ResultList
				teasers={ sortByFromDate(filteredData, isFiltered) }
				teasersPerPage={ 10 }
				currentPage={ currentPage }
				onPageChange={ page => setCurrentPage(page.selected) }
				labelReadMore={ t.resultList.labelReadMore }
				labelResultCountSingular={ t.resultList.labelResultCountSingular }
				labelResultCountPlural={ t.resultList.labelResultCountPlural }
				labelPrevious={ t.resultList.labelPrevious }
				labelNext={ t.resultList.labelNext }
				ariaLabelPage={ t.resultList.ariaLabelPage }
			/>
		</div>
	);
};

export default hot(module)(Form);
